module.exports = __webpack_public_path__ + "static/img/GB.7a95a69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries/GB.svg
// module id = WMro
// module chunks = 1